import { HttpClient } from "@angular/common/http";
import { Injectable } from "@angular/core";
import { Observable } from "rxjs";
import { environment } from "src/environments/environment";
import { Constants } from "../data/constants";
import { CalculatePrice } from "../models/calcul/calculatePrice";
import { FilterLocationPartnersToCreateCampaign } from "../models/location-partners/filterBySubCategoriesAndTagLocationPartner";
import { LocationPartnerInterface } from "../models/location-partners/locationPartner.interface";
import { LocationPartnersFilterInterface } from "../models/location-partners/locationPartnersFilter.interface";
import { LocationPartnersResultInterface } from "../models/location-partners/locationPartnersResult.interface";
import { ResultMainStaticsForLP } from "../models/location-partners/resultMainStaticsLP";
import { SuccessDto } from "../models/success-dto";
import { PricingInterface } from "src/app/shared/models/location-partners/pricing";
import { LPInfo } from "../models/location-partners/lpInfo";
import { Pager } from "../models/pagination";
import { FilterLastWeekForLPReview } from "../models/location-partners/filterLastWeekForLPReview";
import { CreateLPInterface } from "../models/location-partners/createLP";
import { CalculateAverageViewsDto } from "../models/location-partners/CalculateAverageViewsDto";
import {
  LocationPartnersImpressionsFilterInterface,
  LocationPartnersImpressionsResult,
} from "../models/location-partners/locationPartnersImpressions";
import { GrantPremiumAccess } from "../models/location-partners/GrantPremiumAccess";
import { UpdatePaymentLP } from "../models/update-payment-LP.interface";
import { PricingMethod } from "../enum/pricing-method";
import { AdvertisingCampaignsPaymentLP } from "../models/advertising-campaigns/advertising-campaigns-payment-LP.interface";
import { UpdateAverageViews } from "../models/location-partners/updateAverageViewsDto";
import { RemunerationFilterDto } from "../models/franchise/remunerationFilterDto.interface";
import { FranchisesRemunerationWithResultDto } from "../models/franchise/franchisesRemunerationWithResultDto.interface";
import { AssociateLPToFranchiseRequestDto } from "../models/franchise/AssociateLPToFranchiseRequestDto";
import { LocationPartnersPricesFilterInterface, LocationPartnersPricesResult, UpdatePricesDto } from "../models/location-partners/locationPartnersPrices";
import { TotalPriceWithDiscount } from "../models/calcul/totalPrice";

@Injectable({
  providedIn: "root",
})
export class LocationPartnersService {
  constructor(private http: HttpClient) {}

  getAllLocationPartnerByFilter(
    localisationPartnerFilter: LocationPartnersFilterInterface
  ): Observable<LocationPartnersResultInterface> {
    return this.http.post<LocationPartnersResultInterface>(
      `${environment.APP_PORT + Constants.LOCATION_PARTNER_ENDPOINT}/filter`,
      localisationPartnerFilter
    );
  }

  getAllLocationPartnersByCompanyNames(
    companyNames: string[] | null
  ): Observable<LocationPartnerInterface[]> {
    return this.http.post<LocationPartnerInterface[]>(
      `${
        environment.APP_PORT + Constants.LOCATION_PARTNER_ENDPOINT
      }/allLocationPartnersByCompanyNames`,
      companyNames
    );
  }

  getLocationPartnerByCompanyName(
    companyName: string | null
  ): Observable<LPInfo> {
    return this.http.get<LPInfo>(
      `${environment.APP_PORT + Constants.LOCATION_PARTNER_ENDPOINT}/info/` +
        companyName
    );
  }

  getLPInfo(): Observable<LPInfo | null> {
    return this.http.get<LPInfo>(
      `${
        environment.APP_PORT + Constants.LOCATION_PARTNER_ENDPOINT
      }/infoByToken`
    );
  }

  getAllLocationPartnersCompanyNames(excludeFranchised: boolean | null = false): Observable<string[]> {
    return this.http.get<string[]>(
      `${
        environment.APP_PORT + Constants.LOCATION_PARTNER_ENDPOINT
      }/allCompanyNames/excludeFranchised/${excludeFranchised}`
    );
  }

  deleteAccount(email: string): Observable<SuccessDto> {
    return this.http.delete<SuccessDto>(
      `${environment.APP_PORT + Constants.LOCATION_PARTNER_ENDPOINT}/${email}`
    );
  }
  filterLocationPartnersToCreateCampaign(
    filter: FilterLocationPartnersToCreateCampaign
  ): Observable<LocationPartnerInterface[] | null> {
    return this.http.post<LocationPartnerInterface[] | null>(
      `${
        environment.APP_PORT + Constants.LOCATION_PARTNER_ENDPOINT
      }/filterLocationPartnersToCreateCampaign`,
      filter
    );
  }
  calculateTotalLPCostByCampanyNames(
    calculatePrice: CalculatePrice
  ): Observable<TotalPriceWithDiscount> {
    return this.http.post<TotalPriceWithDiscount>(
      `${
        environment.APP_PORT + Constants.LOCATION_PARTNER_ENDPOINT
      }/calculate/cost/locations`,
      calculatePrice
    );
  }

  calculateTotalLPPriceByCampanyNames(
    calculatePrice: CalculatePrice
  ): Observable<TotalPriceWithDiscount> {
    return this.http.post<TotalPriceWithDiscount>(
      `${
        environment.APP_PORT + Constants.LOCATION_PARTNER_ENDPOINT
      }/v2/calculate/cost/locations`,
      calculatePrice
    );
  }

  createLocationPartner(
    createLocationPartner: CreateLPInterface
  ): Observable<SuccessDto> {
    return this.http.post<SuccessDto>(
      `${environment.APP_PORT + Constants.LOCATION_PARTNER_ENDPOINT}/create`,
      createLocationPartner
    );
  }
  updateLocationPartner(
    updateLocationPartner: LocationPartnerInterface | null,
    email: string | null
  ): Observable<SuccessDto> {
    return this.http.patch<SuccessDto>(
      `${
        environment.APP_PORT + Constants.LOCATION_PARTNER_ENDPOINT
      }/fullProfile/` + email,
      updateLocationPartner
    );
  }

  getMainStaticsForLP(
    authentification: string
  ): Observable<ResultMainStaticsForLP> {
    return this.http.get<ResultMainStaticsForLP>(
      `${environment.APP_PORT + Constants.LOCATION_PARTNER_ENDPOINT}/main`
    );
  }
  getPricingByCompanyName(
    companyName: string
  ): Observable<PricingInterface | null> {
    return this.http.get<PricingInterface | null>(
      `${
        environment.APP_PORT + Constants.LOCATION_PARTNER_ENDPOINT
      }/pricing/${companyName}`
    );
  }
  filterLocationPartnerReview(
    pager: Pager,
    refreshCache: boolean
  ): Observable<FilterLastWeekForLPReview | null> {
    return this.http.post<FilterLastWeekForLPReview>(
      `${
        environment.APP_PORT + Constants.LOCATION_PARTNER_ENDPOINT
      }/${refreshCache}/review`,
      pager
    );
  }

  getLocationPartnersByRegion(
    regionNames: String[]
  ): Observable<string[][] | null> {
    return this.http.post<string[][]>(
      `${environment.APP_PORT + Constants.LOCATION_PARTNER_ENDPOINT}/region`,
      regionNames
    );
  }
  updateLocationAccount(
    Authorization: string,
    locationPartnerDto: LocationPartnerInterface
  ): Observable<SuccessDto | null> {
    return this.http.patch<SuccessDto>(
      `${environment.APP_PORT + Constants.LOCATION_PARTNER_ENDPOINT}/profile`,
      locationPartnerDto
    );
  }
  getLocationPartnersImpressions(
    filter: LocationPartnersImpressionsFilterInterface
  ): Observable<LocationPartnersImpressionsResult> {
    return this.http.post<LocationPartnersImpressionsResult>(
      `${
        environment.APP_PORT + Constants.LOCATION_PARTNER_ENDPOINT
      }/impressions/filter`,
      filter
    );
  }

  getLocationPartnersPrices(
    filter: LocationPartnersPricesFilterInterface
  ): Observable<LocationPartnersPricesResult> {
    return this.http.post<LocationPartnersPricesResult>(
      `${
        environment.APP_PORT + Constants.LOCATION_PARTNER_ENDPOINT
      }/prices/filter`,
      filter
    );
  }

  calculateAndUpdateViewsAverage(
    calculateAverageViews: CalculateAverageViewsDto | null,
    sendMail: boolean
  ): Observable<SuccessDto> {
    const endPoint =
      "/calculateAndUpdateViewsAverage" + (sendMail ? "/sendMail" : "");
    return this.http.post<SuccessDto>(
      `${
        environment.APP_PORT + Constants.LOCATION_PARTNER_ENDPOINT + endPoint
      }`,
      calculateAverageViews
    );
  }

  grantPremiumAccessForLP(
    grantPremiumAccess: GrantPremiumAccess
  ): Observable<SuccessDto | null> {
    return this.http.patch<SuccessDto>(
      `${
        environment.APP_PORT + Constants.LOCATION_PARTNER_ENDPOINT
      }/GrantPremiumAccessLP`,
      grantPremiumAccess
    );
  }
  LPAdsBeforeEndDate(
    endDate: Date | null
  ): Observable<LocationPartnerInterface | null> {
    return this.http.get<LocationPartnerInterface>(
      `${
        environment.APP_PORT + Constants.LOCATION_PARTNER_ENDPOINT
      }/LPHasAds/endDate/${endDate}`
    );
  }

  updatePaymentStatusLP(
    updatePaymentStatusLP: UpdatePaymentLP | null
  ): Observable<SuccessDto | null> {
    return this.http.patch<SuccessDto>(
      `${
        environment.APP_PORT + Constants.LOCATION_PARTNER_ENDPOINT
      }/updatePaymentStatusLp`,
      updatePaymentStatusLP
    );
  }

  getIsPaidAds(companyNames: string[]): Observable<boolean[] | null> {
    return this.http.post<boolean[] | null>(
      `${environment.APP_PORT + Constants.LOCATION_PARTNER_ENDPOINT}/getIsPaid`,
      companyNames
    );
  }

  getAllLocationPartnerByFilterForPayment(
    localisationPartnerFilter: LocationPartnersFilterInterface
  ): Observable<LocationPartnersResultInterface> {
    return this.http.post<LocationPartnersResultInterface>(
      `${
        environment.APP_PORT + Constants.LOCATION_PARTNER_ENDPOINT
      }/payment/filter`,
      localisationPartnerFilter
    );
  }

  locationPartnerAdvertisingCampignFilter(
    remunerationFilter: RemunerationFilterDto | null,
    refreshCache: boolean
  ): Observable<AdvertisingCampaignsPaymentLP | null> {
    return this.http.post<AdvertisingCampaignsPaymentLP | null>(
      `${
        environment.APP_PORT + Constants.LOCATION_PARTNER_ENDPOINT
      }/remuneration/refreshCache/${refreshCache}`,
      remunerationFilter
    );
  }

  updateViewsAverage(
    updateViewsAverage: UpdateAverageViews | null
  ): Observable<SuccessDto> {
    return this.http.patch<SuccessDto>(
      `${
        environment.APP_PORT + Constants.LOCATION_PARTNER_ENDPOINT
      }/update-views-average`,
      updateViewsAverage
    );
  }

  updateAPIkey(publicApiKey: string, email: string): Observable<SuccessDto> {
    return this.http.patch<SuccessDto>(
      `${
        environment.APP_PORT + Constants.LOCATION_PARTNER_ENDPOINT
      }/publicApiKey/${email}`,
      publicApiKey
    );
  }

  remunerationDetails(
    filter: RemunerationFilterDto,
    refreshCache: boolean
  ): Observable<FranchisesRemunerationWithResultDto> {
    return this.http.post<FranchisesRemunerationWithResultDto>(
      `${
        environment.APP_PORT + Constants.LOCATION_PARTNER_ENDPOINT
      }/remuneration/filter/refreshCache/${refreshCache}`,
      filter
    );
  }
  
  assignLPToFranchise(associateLPToFranchiseRequestDto: AssociateLPToFranchiseRequestDto) : Observable<SuccessDto> {
    return this.http.post<SuccessDto>(
      `${
        environment.APP_PORT + Constants.LOCATION_PARTNER_ENDPOINT
      }/lp-to-franchise
      `,
      associateLPToFranchiseRequestDto
    )
  }

  updateLocationPrices(
    updatePrices: UpdatePricesDto | null
  ): Observable<SuccessDto | null> {
    return this.http.patch<SuccessDto>(
      `${
        environment.APP_PORT + Constants.LOCATION_PARTNER_ENDPOINT
      }/updatePrices`,
      updatePrices
    );
  }
}
